import { BrazeInboxMessageCardDto } from '@marketplace-web/braze/braze-data'
import { ConversationListItemType } from '@marketplace-web/messaging/conversation-messaging-data'

export const isBrazeConversation = (
  conversation: ConversationListItemType,
): conversation is BrazeInboxMessageCardDto => 'extras' in conversation

export const getConversationIdFromUrl = (relativeUrl: string) => {
  const id = relativeUrl.substring(relativeUrl.lastIndexOf('/') + 1)

  if (['inbox', 'new'].includes(id)) {
    return ''
  }

  return id
}
